import { createRestApiClient } from '../index';

export const getUserLocationData = async () => {
  const restApiClient = createRestApiClient();
  const url = `api/getUserLocation`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      headers: { 'Mylo-In-App': false },
    })
    .then((res) => res?.data?.data);
  return data;
};
